module.exports = __webpack_public_path__ + "img/商标异议_08.54a8d52e.jpg";